import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static environment: HostEnvironment = 'test';
  static buildId = '';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static oidc_clientid = '';
  static oidc_scope = '';
  static domainsForApiManagementSubsKey: string[];

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
  };

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    STATUS_PALDESK_PAGE: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    STATUS_PALDESK_PAGE: '',
  };
}
